import React from 'react';

const Review = () => {
    return (
        <div>
            <h1>Hi i am review</h1>
        </div>
    );
};

export default Review;